import React, { useEffect, useState } from "react";
import { Game } from "@yandex-int/hr-components/Game";
import { useAccessDeniedPageTranslations } from "./lib/i18n";
import styles from "./access-deinied-page.module.scss"

interface IAccessDeniedPageProps {
    errorStatus?: number;
}

export const AccessDeniedPage: React.FC<IAccessDeniedPageProps> = ({ errorStatus }) => {
    const t = useAccessDeniedPageTranslations();
    const [condition, setCondition] = useState<boolean>(false);

    // костыль для библиотеки hr-tech, иначе показывает серую подложку
    useEffect(() => {
        setTimeout(() => {
            setCondition(true);
        })
    }, [])

    return (
        <div className={styles.root}>
            <div className={styles.errorContainer}>
                {condition && <div className={styles.gameContainer}><Game errorCode={errorStatus}/></div>}
                <div className={styles.errorText}>
                    {errorStatus === 404 && <>
                        <div className={styles.title}>
                            {t("error")}
                        </div>
                        <div className={styles.info}>
                            {t("404info")}
                        </div>
                    </>}
                </div>
            </div>
        </div>
    );
};
